/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetReferenceDataResponse } from './api.schemas';

import { api } from '../util/http';

export const getReferenceData = (signal?: AbortSignal) => {
  return api<GetReferenceDataResponse>({ url: `/api/reference-data`, method: 'GET', signal });
};

export const getGetReferenceDataQueryKey = () => {
  return [`/api/reference-data`] as const;
};

export const getGetReferenceDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getReferenceData>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceData>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReferenceDataQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferenceData>>> = ({ signal }) =>
    getReferenceData(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReferenceData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReferenceDataQueryResult = NonNullable<Awaited<ReturnType<typeof getReferenceData>>>;
export type GetReferenceDataQueryError = unknown;

export function useGetReferenceData<
  TData = Awaited<ReturnType<typeof getReferenceData>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceData>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceData>>,
          TError,
          Awaited<ReturnType<typeof getReferenceData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReferenceData<
  TData = Awaited<ReturnType<typeof getReferenceData>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceData>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceData>>,
          TError,
          Awaited<ReturnType<typeof getReferenceData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReferenceData<
  TData = Awaited<ReturnType<typeof getReferenceData>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceData>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetReferenceData<
  TData = Awaited<ReturnType<typeof getReferenceData>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferenceData>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReferenceDataQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
